<div class="factoring-simulator" [style.--hero-img]="'url(' + randomImage + ')'">
  <!-- layout -->
  <header class="header">
    <div class="logo">
      <img src="../../assets/simpli/simpli-azul.svg" height="50px">
      <img src="https://simpliassets12daacw.s3.us-east-2.amazonaws.com/Ingram_micro_logo.png" height="30px" style="margin-left: 10px;">

    </div>
    <div class="nav">
      @if (!showRutStep) {
        <button class="btn-login2" (click)="simularOtraRut()">
          <span class="material-symbols-outlined" style="font-size:18px;line-height:1;vertical-align:middle;">refresh</span>
          <span style="vertical-align:middle;">Simular otro RUT</span>
        </button>
      }
      <button class="btn-login" (click)="salir()">Salir</button>
    </div>
  </header>

  <!-- titulo -->
  <section class="hero">
    <div class="title">
      <span class="titulo">Acelerador de financiamiento</span>
    </div>
    <div class="subtitle">
      <span class="subtitulo">Alianza<br> <strong>Ingram - Simpli</strong></span>
    </div>
    <div class="highlight">
      <span class="subtitulo2">{{ typewriterPart1 }}<span class="subtitulo3">{{ typewriterPart2 }}</span><span class="typewriter-cursor" [class.typewriter-cursor--done]="typewriterDone">|</span></span>
    </div>
    <div class="subtitle">
      <span class="subtitulo3">Simulador de factoring</span>
    </div>
  </section>

  <!-- RUT step previo a simulación -->
  @if (showRutStep) {
  <div class="main-content-band">
  <div class="main-content rut-step-center">
    <div class="card simulation-card rut-step-card">
      <div class="card-header">
        <mat-icon class="">badge</mat-icon>
        <div class="titulo-header">Ingresa el RUT del cliente para comenzar la simulación</div>
      </div>
      <div class="card-body">

        <!-- RUT input -->
        <mat-form-field appearance="outline" class="sim-field">
          <mat-label>RUT de la empresa</mat-label>
          <input matInput type="text" placeholder="12345678-9"
            [value]="rut"
            (input)="onRutInput($any($event.target).value)"
            (blur)="onRutBlur()"
            (keyup.enter)="onRutBlur()"
            [disabled]="rutLoading"
            maxlength="12"
            [errorStateMatcher]="rutErrorMatcher">
          @if (rutLoading) {
            <span matSuffix class="material-symbols-outlined mat-spin sim-suffix-spin">progress_activity</span>
          }
          <mat-error>
            @if (rutStatus === 'blocked') {
              <mat-icon style="font-size:13px;width:13px;height:13px;line-height:13px;vertical-align:middle;">block</mat-icon>
              {{ rutErrorMsg }}
            }
            @if (rutStatus === 'error') { {{ rutErrorMsg }} }
          </mat-error>
        </mat-form-field>

        <!-- Tramo info -->
        @if (isPersonaNatural) {
          <div class="tramo-badge tramo-badge--warn" style="margin-bottom:8px;">
            <mat-icon style="font-size:14px;width:14px;height:14px;line-height:14px;">person</mat-icon>
            Persona natural
          </div>
        }
        @if (tramoMessage) {
          <div class="tramo-message">
            <mat-icon style="font-size:16px;width:16px;height:16px;line-height:16px;color:var(--simpli-color1);flex-shrink:0;">info</mat-icon>
            {{ tramoMessage }}
          </div>
          @if (tramoAceptado !== null) {
            <div class="tramo-badge" style="margin-top:4px;" [class.tramo-badge--ok]="tramoAceptado" [class.tramo-badge--no]="!tramoAceptado">
              <mat-icon style="font-size:14px;width:14px;height:14px;line-height:14px;">{{ tramoAceptado ? 'verified' : 'cancel' }}</mat-icon>
              {{ tramoAceptado ? 'Tramo aceptado por Simpli' : 'Tramo no aceptado por Simpli' }}
            </div>
          }
          @if (tramoRangeMin !== null && tramoRangeMax !== null) {
            <div class="tramo-message" style="margin-top:4px;font-size:12px;color:#555;">
              <mat-icon style="font-size:13px;width:13px;height:13px;line-height:13px;color:#555;flex-shrink:0;">bar_chart</mat-icon>
              Facturación: {{ tramoRangeMin | number:'1.0-0' }} – {{ tramoRangeMax | number:'1.0-0' }} UF/año
            </div>
          }
        }

        <!-- Nombre empresa -->
        @if (rutStatus === 'ok') {
          <mat-form-field appearance="outline" class="sim-field" style="margin-top:16px;">
            <mat-label>Nombre de la empresa</mat-label>
            <input matInput type="text" placeholder="Nombre de la empresa"
              [(ngModel)]="businessName"
              [disabled]="businessNameReadonly"
              style="text-transform: uppercase;"
              [errorStateMatcher]="businessNameErrorMatcher">
            <mat-error>
              <mat-icon style="font-size:13px;width:13px;height:13px;line-height:13px;vertical-align:middle;">warning</mat-icon>
              El nombre de la empresa es requerido para continuar.
            </mat-error>
          </mat-form-field>

          <!-- Simular button -->
          <div class="btn-container" style="margin-top: 24px;">
            <button
              class="primary-button"
              mat-flat-button
              color="primary"
              [disabled]="simulandoLoading || !businessName"
              (click)="onSimular()"
            >
              @if (simulandoLoading) {
                <span><span class="material-symbols-outlined mat-spin" style="color:var(--simpli-secondary);font-size:18px;">progress_activity</span></span>
              } @else {
                <mat-label>Simular →</mat-label>
              }
            </button>
          </div>
        }
      </div>
    </div>
  </div>
  </div>
  }

  <!-- titulo -->
  @if (!showRutStep) {
  <div class="main-content-band">

  @if (showOnboardingForm) {
  <!-- Onboarding form -->
  <div class="onboarding-form-wrap">
    <div class="onboarding-form-card">
      <div class="onboarding-form-header">
        <button class="onboarding-volver" (click)="volverSimulacion()">
          <span class="material-symbols-outlined" style="font-size:18px;vertical-align:middle;">arrow_back</span>
          <span style="vertical-align:middle;">Volver a la simulación</span>
        </button>
      </div>

      @if (!onboardingRegistrado) {
        <div class="onboarding-form-title">Para proceder con el onboarding, primero necesitas completar los siguientes datos</div>

        <mat-form-field appearance="outline" class="sim-field">
          <mat-label>Nombre <span class="req">*</span></mat-label>
          <input matInput type="text" [(ngModel)]="onboardingNombre" placeholder="Ej: Juan Pérez"
            [errorStateMatcher]="onboardingNombreErrorMatcher">
          <mat-error>{{ onboardingNombreError }}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="sim-field">
          <mat-label>Correo electrónico <span class="req">*</span></mat-label>
          <input matInput type="email" [(ngModel)]="onboardingEmail" placeholder="Ej: juan@empresa.cl"
            [errorStateMatcher]="onboardingEmailErrorMatcher">
          <mat-error>{{ onboardingEmailError }}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="sim-field">
          <mat-label>Teléfono <span class="req">*</span></mat-label>
          <input matInput type="text" [ngModel]="onboardingTelefono" (ngModelChange)="onTelefonoInput($event)"
            placeholder="Ej: 912345678" maxlength="9" inputmode="numeric"
            [errorStateMatcher]="onboardingTelefonoErrorMatcher">
          <mat-error>{{ onboardingTelefonoError }}</mat-error>
        </mat-form-field>

        <button class="btn-registrar" (click)="registrarOnboarding()" [disabled]="registrandoLoading">
          @if (registrandoLoading) {
            <span class="material-symbols-outlined mat-spin" style="font-size:20px;vertical-align:middle;margin-right:6px;">progress_activity</span>Registrando...
          } @else {
            Registrar
          }
        </button>
      } @else {
        <div class="onboarding-success">
          <span class="material-symbols-outlined" style="font-size:52px;color:var(--simpli-color7);">check_circle</span>
          <div class="onboarding-success-title">¡Datos registrados con éxito!</div>
          <div class="onboarding-success-sub">Comunícale esto a tu cliente para que pueda acceder al portal, revisar su simulación y continuar con el proceso de onboarding.</div>

          <div class="credenciales-card">
            <div class="credenciales-row">
              <span class="credenciales-label">Email</span>
              <span class="credenciales-value">{{ onboardingPortalEmail }}</span>
            </div>
            <div class="credenciales-row">
              <span class="credenciales-label">Contraseña</span>
              <span class="credenciales-value">{{ onboardingPortalPassword }}</span>
            </div>
            <div class="credenciales-row">
              <span class="credenciales-label">Portal</span>
              <a class="credenciales-link" [href]="portalUrl" target="_blank">{{ portalUrl }}</a>
            </div>
            <button class="credenciales-copy-btn" (click)="copiarCredenciales()">
              <span class="material-symbols-outlined" style="font-size:18px;vertical-align:middle;margin-right:5px;">{{ credencialesCopied ? 'check' : 'content_copy' }}</span>
              <span style="vertical-align:middle;">{{ credencialesCopied ? '¡Copiado!' : 'Copiar credenciales' }}</span>
            </button>
          </div>
        </div>
      }
    </div>
  </div>
  } @else {

  <div class="main-content">
    <!-- simular operacion -->
    <div class="card simulation-card">
      <div class="card-header">
        <mat-icon class="">calculate</mat-icon>
        <div class="header-text">
          <div class="titulo-header">Simula tu operación</div>
        </div>
      </div>
      <div class="card-body">
        <!-- Empresa info strip -->
        @if (businessName || tramoNumber !== null || isPersonaNatural) {
          <div class="empresa-info-strip">
            @if (businessName) {
              <div class="empresa-strip-name">
                {{ businessName | uppercase }}
                @if (rut) { <span class="empresa-strip-rut">({{ rut }})</span> }
              </div>
            }
            <div class="empresa-strip-meta">
              @if (tramoNumber !== null) {
                <span class="tramo-sim-label">Tramo {{ tramoNumber }}</span>
                <span class="tramo-badge tramo-badge--sm" [class.tramo-badge--ok]="tramoAceptado" [class.tramo-badge--no]="!tramoAceptado">
                  <mat-icon style="font-size:11px;width:11px;height:11px;line-height:11px;">{{ tramoAceptado ? 'verified' : 'cancel' }}</mat-icon>
                  {{ tramoAceptado ? 'Aceptado por Simpli' : 'No aceptado por Simpli' }}
                </span>
                @if (tramoRangeMin !== null && tramoRangeMax !== null) {
                  <span class="tramo-sim-label" style="font-size:11px;">
                    · Facturación: {{ tramoRangeMin | number:'1.0-0' }} – {{ tramoRangeMax | number:'1.0-0' }} UF/año
                  </span>
                }
              }
              @if (isPersonaNatural) {
                <span class="tramo-badge tramo-badge--sm tramo-badge--warn">
                  <mat-icon style="font-size:11px;width:11px;height:11px;line-height:11px;">person</mat-icon>
                  Persona natural
                </span>
              }
            </div>
          </div>
        }
        <div class="subtitulo-header">* Ajusta los parámetros para conocer los términos de tu financiamiento</div>

        <!-- costo cotización -->
        <div class="form-group">
          <mat-form-field appearance="outline" class="sim-field">
            <mat-label>Costo de la cotización</mat-label>
            <span matPrefix class="material-symbols-outlined">
              attach_money
            </span>
            <input matInput type="text" [value]="cotizacionAmount | number:'1.0-0'"
              (input)="onAmountInput($any($event.target).value)">
          </mat-form-field>
          <div class="quick-amounts">
            <button class="quick-btn" (click)="setAmount(500000)">500K</button>
            <button class="quick-btn" (click)="setAmount(1000000)">1M</button>
            <button class="quick-btn" (click)="setAmount(2000000)">2M</button>
            <button class="quick-btn" (click)="setAmount(5000000)">5M</button>
            <button class="quick-btn" (click)="setAmount(10000000)">10M</button>
            <button class="quick-btn" (click)="setAmount(50000000)">50M</button>
            <button class="quick-btn" (click)="setAmount(120000000)">120M</button>
          </div>
        </div>

        <!-- margen comercial -->
        <div class="form-group">
          <label>Margen comercial:
            <span class="percentage-value">{{ margenPercent }}%</span>
          </label>
          <div class="slider-container">
            <input type="range" min="10" max="70" step="1" class="slider" [value]="margenPercent"
              (input)="setMargen($any($event.target).valueAsNumber)" [style.--min]="10" [style.--max]="70"
              [style.--val]="margenPercent" />
            <div class="slider-labels">
              <span>10%</span><span>70%</span>
            </div>
          </div>
        </div>

        <!-- monto de la factura (calculado) + número factura -->
        <div class="form-row-2col">
          <div class="form-group">
            <mat-form-field appearance="outline" class="sim-field">
              <mat-label>Monto de la factura</mat-label>
              <span matPrefix class="material-symbols-outlined">
                attach_money
              </span>
              <input matInput type="text" [value]="invoiceAmount | number:'1.0-0'" [disabled]="true">
              <mat-hint>cotización × {{ 1 + margenPercent / 100 | number:'1.2-2' }}</mat-hint>
            </mat-form-field>
          </div>
          <div class="form-group">
            <mat-form-field appearance="outline" class="sim-field">
              <mat-label>N° de la factura <span style="font-size:11px;">(opcional)</span></mat-label>
              <input matInput type="text" placeholder="Ej: 12345"
                [ngModel]="facturaNumero" (ngModelChange)="facturaNumero=$event; invalidarSimulacion()">
            </mat-form-field>
          </div>
        </div>

        <!-- RUT deudor -->
        <div class="form-group">
          <mat-form-field appearance="outline" class="sim-field">
            <mat-label>RUT deudor <span style="font-size:11px;">(opcional)</span></mat-label>
            <input matInput type="text" placeholder="Ej: 76123456-7"
              [value]="deudorRut"
              (input)="onDeudorRutInput($any($event.target).value)"
              maxlength="12"
              [errorStateMatcher]="deudorRutErrorMatcher">
            @if (deudorRutStatus === 'loading') {
              <span matSuffix class="material-symbols-outlined mat-spin sim-suffix-spin">progress_activity</span>
            }
            @if (deudorRutStatus === 'valid') {
              <mat-icon matSuffix class="sim-suffix-ok">check_circle</mat-icon>
            }
            @if (deudorRutStatus === 'valid' && promedioDias !== null) {
              <mat-hint style="color:#2e7d32;">
                Promedio días: <strong>{{ promedioDias === 0 ? 'sin registros (usando 30 días)' : promedioDias + ' días' }}</strong>
              </mat-hint>
            }
            <mat-error>RUT inválido</mat-error>
          </mat-form-field>
        </div>

        <!-- plazo pago -->
        <div class="form-group">
          <label>Plazo de pago de la factura</label>
          <div class="payment-terms">
            <button class="term-btn" [class.active]="termDays===30" (click)="setTermDays(30)">30 días</button>
            <button class="term-btn" [class.active]="termDays===45" (click)="setTermDays(45)">45 días</button>
            <button class="term-btn" [class.active]="termDays===50" (click)="setTermDays(50)">50 días</button>
            <button class="term-btn" [class.active]="termDays===60" (click)="setTermDays(60)">60 días</button>
            <button class="term-btn" [class.active]="termDays===90" (click)="setTermDays(90)">90 días</button>
            <button class="term-btn" [class.active]="termDays===120" (click)="setTermDays(120)">120 días</button>
            <div class="custom-term">
              <span>Otro plazo:</span>
              <input type="number" [value]="termDays" (input)="setTermDays($any($event.target).valueAsNumber)"
                class="custom-input">
              <span>días</span>
            </div>
          </div>
        </div>

        <!-- porcentaje anticipo -->
        <div class="form-group">
          <label>Porcentaje de anticipo:
            <span class="percentage-value">{{ advancePercent }}%</span>
          </label>

          <div class="slider-container">
            <input type="range" min="70" max="100" step="5" class="slider" [value]="advancePercent"
              (input)="setAdvance($any($event.target).valueAsNumber)" [style.--min]="70" [style.--max]="100"
              [style.--val]="advancePercent" />

            <div class="slider-labels">
              <span>70%</span><span>100%</span>
            </div>
          </div>
        </div>

        <!-- tasa de interes -->
        <div class="form-group">
          <label>
            Tasa de interés mensual:
            <span class="rate-value">{{ effectiveMonthlyRatePercent | number:'1.1-2'}}%</span>
          </label>

          <div class="slider-container">
            <input type="range" [min]="rateMin" [max]="rateMax" step="0.1" class="slider" [(ngModel)]="monthlyRatePercent"
              (ngModelChange)="onRateChange($event)" [style.--min]="rateMin" [style.--max]="rateMax"
              [style.--val]="monthlyRatePercent" />
            <div class="slider-labels">
              <span>{{ rateMin }}%</span><span>{{ rateMax }}%</span>
            </div>
          </div>

          <p class="rate-note">Tasa mínima: {{ rateMin }}%</p>
        </div>

        @if (showSavingsBanner) {
        <div class="savings-info">
          <mat-icon class="savings-icon">emoji_events</mat-icon>
          <div class="savings-text">
            <strong>¡Estás ahorrando!</strong><br>
            Competencia promedio: {{ competitorAvgPctDisplay | number:'1.1-1' }}% •
            Tu ahorro: {{ savingsDeltaPct | number:'1.1-1' }}%
          </div>
        </div>
        }

      </div>
    </div>

    <!-- liquidez -->
    <div class="card results-card">
      <div class="card-header">
        <mat-icon class="material-symbols-outlined">paid</mat-icon>
        <div class="titulo-header">Tu liquidez al instante</div>
      </div>
      <div class="card-body">
        <!-- sumario -->
        <div class="amount-summary">
          <div class="amount-row">
            <span>Monto facturas</span>
            <span class="amount">${{ invoiceAmount | number:'1.0-0' }}</span>
          </div>
          <div class="amount-row">
            <span>Monto financiado {{ advancePercent}} %</span>
            <span class="amount">${{ financedAmount | number:'1.0-0' }}</span>
          </div>
        </div>

        <!-- Cost Breakdown -->
        <div class="cost-breakdown">
          <div class="cost-item">
            <div class="amount-text">Costo financiamiento</div>
            <span class="cost-amount">${{ financingCost | number:'1.0-0' }}</span>
          </div>
          <div class="cost-item">
            <div class="amount-text">Comisión Simpli</div>
            <span class="cost-amount">${{ commissionCost | number:'1.0-0' }}</span>
          </div>
          <div class="cost-item">
            <div class="amount-text">IVA ({{ivaPercent}}%)</div>
            <span class="cost-amount">${{ vatCost | number:'1.0-0' }}</span>
          </div>
        </div>

        <div class="divider"></div>

        <!-- Final Amount -->
        <div class="final-amount success">
          <div class="final-label">Recibes hoy</div>
          <div class="final-value">
            <span class="amount-large">$ {{ receivesToday | number:'1.0-0' }}</span>
            <mat-icon class="icon-amount-large">trending_up</mat-icon>
          </div>
        </div>

        <!-- Saldo al vencimiento -->
        @if ((receivesAtMaturity ?? 0) > 0) {
          <div class="final-amount info" style="margin-top: 10px;">
            <div class="final-label">Recibes al vencimiento</div>
            <div class="final-value">
              <span class="amount-large2">
                ${{ receivesAtMaturity | number:'1.0-0' }}
              </span>
              <mat-icon class="icon-amount-large2">schedule</mat-icon>
            </div>
          </div>
        }

        <!-- Call to Action -->
        @if (!simulacionGuardadaId) {
          <button class="third-button btn-cta btn-guardar" (click)="guardarSimulacion()" [disabled]="guardandoLoading">
            @if (guardandoLoading) {
              <span class="btn-guardar-inner">
                <span class="material-symbols-outlined mat-spin btn-guardar-spinner">progress_activity</span>
                <span class="btn-guardar-label">{{ guardandoMsg }}</span>
              </span>
              <div class="btn-guardar-steps">
                <span class="btn-guardar-step" [class.active]="guardandoStep === 'validando'" [class.done]="guardandoStep === 'guardando'">
                  <span class="step-dot"></span>Validando facturas
                </span>
                <span class="btn-guardar-step" [class.active]="guardandoStep === 'guardando'">
                  <span class="step-dot"></span>Creando simulación
                </span>
              </div>
            } @else {
              Guardar simulación →
            }
          </button>
        } @else {
          <button class="third-button btn-cta btn-descargar" (click)="descargarSimulacion()" [disabled]="descargandoLoading">
            @if (descargandoLoading) {
              <span class="material-symbols-outlined mat-spin" style="font-size:24px;vertical-align:middle;margin-right:6px;">progress_activity</span>Generando PDF...
            } @else {
              <span class="material-symbols-outlined" style="font-size:20px;vertical-align:middle;margin-right:6px;">download</span>Descargar simulación
            }
          </button>
          <button class="btn-onboarding" (click)="abrirOnboarding()">
            Proceder al Onboarding →
          </button>
        }

        <!-- Disclaimer -->
        <div class="disclaimer">*Simulación referencial. Los términos finales pueden variar según evaluación crediticia
          y
          condiciones del mercado.</div>

      </div>
    </div>
  </div>
  }

  </div>
  }

  <!-- Métricas debajo de "Tu liquidez al instante" -->
  <div class="metrics metrics-inline">
    <div class="metric-item">
      <div class="metric-label">Anticipo máximo</div>
      <div class="metric-value">100%</div>
    </div>
    <div class="metric-item">
      <div class="metric-label">Tasa desde</div>
      <div class="metric-value">1.4%</div>
    </div>
    <div class="metric-item">
      <div class="metric-label">Giro en menos</div>
      <div class="metric-value">de 3 horas</div>
    </div>
  </div>

  <!-- Panel: Tu simulación actual -->
  <section class="current-simulation">
    <div class="panel">
      <div class="titulo-simpli panel-header">Un vistazo rápido</div>
      <div class="panel-intro">
        Con una factura de <strong>$2.000.000</strong> a 120 días, <strong>90%</strong> de anticipo y una
        tasa del <strong>3.1%</strong> mensual.
      </div>
      <div class="summary-tiles">
        <div class="tile tile-liquidez">
          <mat-icon class="icon-amount-large4">trending_up</mat-icon>
          <div class="tile-title">Liquidez inmediata</div>
          <div class="tile-value">$1.521.183</div>
          <div class="tile-desc">Dinero que recibes hoy para tu flujo de caja</div>
        </div>
        <div class="tile tile-costo">
          <mat-icon class="icon-amount-large4">attach_money</mat-icon>
          <div class="tile-title">Costo total</div>
          <div class="tile-value highlight">$278.817</div>
          <div class="tile-desc">Incluye financiamiento, comisión e IVA</div>
        </div>
        <div class="tile tile-vencimiento">
          <mat-icon class="icon-amount-large4">schedule</mat-icon>
          <div class="tile-title">Al vencimiento</div>
          <div class="tile-value">$200.000</div>
          <div class="tile-desc">Saldo que recibes cuando se pague la factura</div>
        </div>
      </div>
    </div>
  </section>

  <!-- Sección: Cómo ajustar y Ventajas -->
  <section class="how-and-benefits">
    <div class="how-card">
      <div class="titulo-simpli how-title"><mat-icon class="icon-amount-large4">attach_money</mat-icon>¿Cómo editar tu
        simulación?</div>
      <ol class="how-list">
        <li>En el simulador, modifica el <strong>monto de tu factura</strong> para ver cómo mejoran las condiciones</li>
        <li>Cambia el <strong>plazo de pago</strong> según tu contrato</li>
        <li>Ajusta el <strong>porcentaje de anticipo</strong> que necesitas</li>
        <li>La <strong>tasa se ajusta automáticamente</strong> según tu operación</li>
      </ol>
    </div>

    <div class="benefits-card">
      <div class="titulo-simpli benefits-title"><mat-icon class="icon-amount-large4">check</mat-icon> Ventajas de operar con<span style="text-transform: capitalize;margin-left: -5px;">Simpli</span>
      </div>
      <ul class="benefits-list">
        <li><mat-icon class="icon-amount-large2">check_circle_outline</mat-icon> Lo que simulas es lo que pagas, sin letra chica</li>
        <li><mat-icon class="icon-amount-large2">check_circle_outline</mat-icon> Tus fondos el día y hora acordados, con notificación al momento del giro</li>
        <li><mat-icon class="icon-amount-large2">check_circle_outline</mat-icon> Ejecutivo dedicado que te acompaña y conoce tu negocio</li>
        <li><mat-icon class="icon-amount-large2">check_circle_outline</mat-icon> Sigues cada gestión de cobranza en tiempo real, cuidando tu relación con el deudor</li>
      </ul>
    </div>
  </section>

  <!-- Título: Comprende tus resultados -->
  <div class="title results-heading">Comprende tus resultados</div>

  <!-- Bloque informativo de tres columnas -->
  <section class="results-info">
    <div class="info-tile">
      <mat-icon class="icon-amount-large4">update</mat-icon>
      <div class="titulo-simpli info-title">Liquidez inmediata</div>
      <div class="subtitle info-text">El monto que recibes hoy es tu factura menos los costos totales. Esta es la
        liquidez real
        para tu negocio.</div>
    </div>
    <div class="info-tile">
      <mat-icon class="icon-amount-large4">attach_money</mat-icon>
      <div class="titulo-simpli info-title">Estructura de costos</div>
      <div class="subtitle info-text">Incluye financiamiento (2.4%% mensual), comisión operacional,apertura e IVA</div>
    </div>
    <div class="info-tile">
      <mat-icon class="icon-amount-large4">pending_actions</mat-icon>
      <div class="titulo-simpli info-title">Saldo al vencimiento</div>
      <div class="subtitle info-text">Recibes $100.000 cuando tu cliente pague el total de la factura.</div>
    </div>
  </section>

  <!-- Condiciones Comerciales -->
  <section class="commercial-conditions">
    <div class="title conditions-title">Condiciones Comerciales</div>
    <div class="conditions-card">
      <!--<div class="titulo-simpli conditions-header">Costos Adicionales</div> -->

      <div class="conditions-grid">
        <div class="cond-item">
          <div class="titulo-simpli cond-label">Gastos Operacionales</div>
          <div class="titulo-simpli cond-value">$30.000</div>
          <div class="subtitle cond-note">Fijo por operación</div>
        </div>
        <div class="cond-item">
          <div class="titulo-simpli cond-label">Comisión</div>
          <div class="titulo-simpli cond-value">0,5%</div>
          <div class="subtitle cond-note">Mínimo $50.000</div>
        </div>
        <div class="cond-item">
          <div class="titulo-simpli cond-label">Apertura</div>
          <div class="titulo-simpli cond-value">$98.500</div>
          <div class="subtitle cond-note">Una sola vez</div>
        </div>
      </div>
    </div>
  </section>

  <!-- Claim grande + beneficios -->
  <section class="claim-and-features">
    <div class="title big-claim">factoring rápido y simple, con <span class="subtitulo3">liquidez al instante_</span>
    </div>
    <div class="subtitle claim-sub">Hacemos que las Pymes puedan acceder al financiamiento de una manera fácil.</div>

    <div class="features-grid">
      <div class="feature-card">
        <mat-icon class="icon-amount-large4">bolt</mat-icon>
        <div class="titulo-simpli feature-title">Rapidez sin igual</div>
        <div class="subtitle feature-text">Obtén financiamiento en menos de 24 horas, 100% digital desde tu celular
        </div>
      </div>
      <div class="feature-card">
        <mat-icon class="icon-amount-large4">admin_panel_settings</mat-icon>
        <div class="titulo-simpli feature-title">Seguridad garantizada</div>
        <div class="subtitle feature-text">Solicita el servicio de Factoring en una plataforma segura que cuenta con protección de datos</div>
      </div>
      <div class="feature-card">
        <mat-icon class="icon-amount-large4">emoji_people</mat-icon>
        <div class="titulo-simpli feature-title">Atención personalizada</div>
        <div class="subtitle feature-text">Contamos con un equipo de expertos para acompañarte cada vez que lo necesites</div>
      </div>
    </div>
  </section>

  <!-- Lo que necesitas para empezar -->
  <section class="requirements">
    <div class="title req-title">lo que necesitas para empezar</div>
    <div class="req-grid">
      <div class="req-card">
        <mat-icon class="icon-amount-large4">request_page</mat-icon>
        <div class="titulo-simpli req-heading">Facturas</div>
        <div class="subtitle req-text">Tu empresa debe emitir facturas electrónicas a crédito</div>
      </div>
      <div class="req-card">
        <mat-icon class="icon-amount-large4">workspace_premium</mat-icon>
        <div class="titulo-simpli req-heading">Certificado Digital</div>
        <div class="subtitle req-text">Para firmar electrónicamente la operación</div>
      </div>
    </div>

    <div class="subtitle requirements-sub">Hacemos que las Pymes puedan acceder al financiamiento de una manera fácil.</div>

  </section>

  <!-- CTA inferior -->
  <section class="cta-band">
    <div class="titulo-simpli cta-title">¿listo para obtener tu liquidez?</div>
    <div class="cta-sub">Únete a miles de empresas que ya confían en Simpli.</div>
    <div class="cta-actions">
      <button class="btn-cta-primary" (click)="hazteCliente()">hazte cliente →</button>
      <button class="btn-cta-secondary" (click)="explorarApp()">Descargar App</button>
    </div>
    <div class="cta-legal">
      <div>© 2025 Simpli Latam. Todos los derechos reservados.</div>
      <div>Los resultados de esta simulación son referenciales y están sujetos a evaluación crediticia.</div>
    </div>
  </section>
</div>